export var CallProcessing = function(){
  let web_socket = null;

  return {
    js_callback: null,

    // This is expected to be called on each call processing page
    // where we use web sockets to process call data.
    // callback function is used to return json data to the calling javascript code 
    // so it can use the data.
    init: function( callback ){
      if (web_socket !== null) {
        console.log('[CallProcessing] web socket already created')
        return web_socket
      }
      
      CallProcessing.js_callback = callback;
      CallProcessing.gWebSocketsRef = this;
      CallProcessing.socketConnected = false;

      this.connectSocket()
    },

    connectSocket: function(){
      // Establish the socket connection
      let protocol = using_https() ? 'wss' : 'ws'
      var call_processing_server = $('#call_processing_server').val();
      if (! call_processing_server) {
        console.log('call_processing_server uri was not found')
        return
      }
      var ws_uri = `${protocol}://${call_processing_server}`
      // var ws_uri = `${protocol}://devapi01.autoid.com:4577`
      // var ws_uri = `${protocol}://aitest.autoid.com:3001`
      console.log('ws_uri: ' + ws_uri)
      web_socket = new WebSocket(ws_uri)
      web_socket.onmessage = function(msg) {
        handle_ws_message(msg)
      }
      web_socket.onopen = function(e) {
        onWSOpen(e)
      }
      web_socket.onclose = function(e) {
        onWSClose(e)
      }
      web_socket.onerror = function(e) {
        onWSError(e)
      }
    },

    // Finds and retuns the processor's info generated from the server.
    // Returns null if not found, otherwise reutrns JSON data
    get_processor_state: function() {
      var processor_data = document.querySelector('#call_processor_ws_data');
      if (processor_data === null) {
        console.log('No processor settings found. Skipping socket setup.')
        return null;
      }
      return JSON.parse( processor_data.getAttribute('value') )
    },

    close: function() {
      console.log('ws closing')
      web_socket.close()
    },

    // Exposed method to let other JS code send data to the web socket.
    send: function(data) {
      if (web_socket === null) {
        console.log('web socket not set')
        return
      }

      if (typeof data === 'object') {
        data = JSON.stringify(data)
      }

      web_socket.send(data);
      noCallDataAlertTimer()
    },

    showNoCallAlert: showNoCallAlert,
    hideNoCallAlert: hideNoCallAlert,

  } // return 


  // returns true if the domain is using https
  function using_https() {return ('https:' == document.location.protocol);}

  function onWSOpen(e){
    console.log('onwsopen ' + JSON.stringify(e))
    CallProcessing.socketConnected = true;
  }
  
  function onWSClose(e) {
    console.log('closing')
    
    CallProcessing.socketConnected = false;

    if (e.code != 1000) {
      // Error code 1000 means that the connection was closed normally
      console.log('Web socket closed abnormally: ' + e.code)
      Common.notify( 'The web socket has been closed. Please wait a moment...', 'danger');
    }

    // add code here to show a warining if the back end goes down  

    // force clients to reconnect
    // need to handle situations so we can reconnect to the same chat etc
    let that = this
    setTimeout(function() {
      console.log('web socket reconnect attempt')
      CallProcessing.gWebSocketsRef.connectSocket();

      // The view that is using sockets is expected to have this function defined
      validate_save_state();
    }, 6000);  
  }

  function onWSError(e){
    console.log('ws error: ' + JSON.stringify(e) )
  }
  
  function handle_ws_message(msg) {
    console.log('handle_ws_message ')
    try {
      if (msg && typeof msg === 'object' && typeof msg.data === 'string') {
        pass_message_to_client(msg.data)
      }
      else {
        console.log('ws recevied unexpected data: ' + msg)
      }
    }
    catch(e) {
      console.log('ws exception: ' + e)
    }
  }

  // Pass any JSON data to the client for processing
  function pass_message_to_client(data) {
    //console.log('ws message json data: ' + data)
    if (CallProcessing.js_callback) {
      CallProcessing.js_callback(data)
    }
    else {
      console.log('No callback provided for CallProcessing.')
    }
  }

  // simple way to see if there is call data loaded in the ui
  // if not, we display an informational panel for the user.
  function noCallDataAlertTimer() {
    setTimeout( function() {
      const callid = $('#call_id').text()
      if (callid === '') {
        showNoCallAlert()  
      }
      else {
        hideNoCallAlert()    
      }
    }, 2000)
  }

  function showNoCallAlert() {
    $('#no_call_avail').removeClass('hide')    
  }

  function hideNoCallAlert() {
    $('#no_call_avail').addClass('hide')    
  }
  
}();

